
import { adminQueries } from "./admin-queries";
import { userQueries } from "./user-queries";
import { QueryResult, QueryDefinition } from "./types";
import { DashboardType } from "../widget-types";

// Combine all queries
export const widgetQueries = {
  ...adminQueries,
  ...userQueries
};

// Get a list of all available queries with their metadata
export const getAvailableQueries = (): QueryDefinition[] => {
  const adminQueryDefinitions = Object.entries(adminQueries).map(([name]) => ({
    name,
    description: `Admin query: ${name}`,
    dashboardTypes: ['admin' as DashboardType]
  }));

  const userQueryDefinitions = Object.entries(userQueries).map(([name]) => ({
    name,
    description: `User query: ${name}`,
    dashboardTypes: ['user' as DashboardType]
  }));

  return [
    ...adminQueryDefinitions,
    ...userQueryDefinitions
  ];
};

// Execute a query by name
export const executeWidgetQuery = async (queryName: string): Promise<QueryResult> => {
  try {
    if (queryName in widgetQueries) {
      return await widgetQueries[queryName]();
    } else {
      return {
        data: null,
        error: new Error(`Query "${queryName}" not found`)
      };
    }
  } catch (error) {
    console.error(`Error executing query "${queryName}":`, error);
    return {
      data: null,
      error
    };
  }
};

// Export types
export type { QueryResult, QueryDefinition };
